module.exports = {
      id: "close-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#close",
      toString: function () {
        return this.url;
      }
    }